import { getAssetPath, h, Host } from "@stencil/core";
const failedImageUrls = {};
export class CountryIcon {
    constructor() {
        this.country = "";
        this.size = "s";
        this.imageUrl = null;
    }
    setCountry() {
        const { country } = this;
        if (country.length < 2) {
            this.imageUrl = null;
            return;
        }
        const imageUrl = getAssetPath(`./assets/flags/${country.toLowerCase()}.png`);
        this.imageUrl = !failedImageUrls[imageUrl] ? imageUrl : null;
    }
    componentWillLoad() {
        this.setCountry();
    }
    handleLoadError = (event) => {
        failedImageUrls[event.target.src] = true;
        this.imageUrl = null;
    };
    render() {
        return (h(Host, { key: '6d7b31435548d594d99a8ea229462a87f996b127', size: this.size }, this.imageUrl !== null && h("img", { key: '3a836b6a60ce5e40bd06c30c84154f875628db99', src: this.imageUrl, alt: this.country, onError: this.handleLoadError }), this.imageUrl === null && this.country));
    }
    static get is() { return "ux-country-icon"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["country-icon.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["country-icon.css"]
        };
    }
    static get assetsDirs() { return ["assets/flags"]; }
    static get properties() {
        return {
            "country": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Country code (ISO-2)"
                },
                "attribute": "country",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"s\" | \"m\" | \"l\"",
                    "resolved": "\"l\" | \"m\" | \"s\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Size of the icon"
                },
                "attribute": "size",
                "reflect": true,
                "defaultValue": "\"s\""
            }
        };
    }
    static get states() {
        return {
            "imageUrl": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "country",
                "methodName": "setCountry"
            }];
    }
}
//# sourceMappingURL=country-icon.js.map
